import { render, staticRenderFns } from "./CaptureBeneficiaries.vue?vue&type=template&id=670dbaaf&scoped=true&"
import script from "./CaptureBeneficiaries.vue?vue&type=script&lang=js&"
export * from "./CaptureBeneficiaries.vue?vue&type=script&lang=js&"
import style0 from "./CaptureBeneficiaries.vue?vue&type=style&index=0&id=670dbaaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670dbaaf",
  null
  
)

export default component.exports